import { axios } from '@Root/API'

export const post = payload => {
  return axios.post(`students/rollover-newly`, payload)
}
